import { ApiBase } from './ApiBase';
class RealtimeStatsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getActiveUsers = () => {
            return this.get('/shops/realtime-stats/active-users');
        };
    }
}
export const RealtimeStatsApiClient = new RealtimeStatsApiClientModel();
